import { Dialog, DialogContent, DialogTitle, Grid, Paper } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import Draggable from "react-draggable";
import * as Yup from "yup";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDInput from "../../../Components/MDInput";
import MDTypography from "../../../Components/MDTypography";

function PaperComponent(props: any) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
const validationSchema = Yup.object().shape({
  Title: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Description: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Gheymat: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
});
export default function AddChild(props: { open: boolean; setClose: any; onDone: any }) {
  const formik = useFormik({
    initialValues: { Title: "", Gheymat: "", Description: "" },
    onSubmit: (data) => {
      props.onDone(data);
    },
    validationSchema,
  });
  return (
    <Dialog open={props.open} onClose={props.setClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <MDTypography variant="h">افزودن زیرشاخه</MDTypography>
      </DialogTitle>
      <DialogContent>
        <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
          <Grid container textAlign={"center"} justifyContent="center" gap={"10px 0"}>
            <Grid item xs={4} alignSelf="center">
              <MDTypography fontSize={"14px"}>عنوان</MDTypography>
            </Grid>
            <Grid item xs={8}>
              <MDInput
                name="Title"
                fullWidth
                size="small"
                onChange={formik.handleChange}
                error={formik.touched.Title && Boolean(formik.errors.Title)}
                value={formik.values.Title}
              />
            </Grid>
            <Grid item xs={4} alignSelf="center">
              <MDTypography fontSize={"14px"}>قیمت</MDTypography>
            </Grid>
            <Grid item xs={8}>
              <MDInput
                name="Gheymat"
                fullWidth
                size="small"
                onChange={formik.handleChange}
                error={formik.touched.Gheymat && Boolean(formik.errors.Gheymat)}
                value={formik.values.Gheymat}
              />
            </Grid>
            <Grid item xs={4} alignSelf="center">
              <MDTypography fontSize={"14px"}>توضیحات</MDTypography>
            </Grid>
            <Grid item xs={8}>
              <MDInput
                name="Description"
                fullWidth
                size="small"
                onChange={formik.handleChange}
                error={formik.touched.Description && Boolean(formik.errors.Description)}
                value={formik.values.Description}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"} alignItems="center">
            <Grid item xs={3} mt={2} mx={5}>
              <MDButton color="error" fullWidth variant="outlined" onClick={props.setClose}>
                بازگشت
              </MDButton>
            </Grid>
            <Grid item xs={3} mt={2} mx={5}>
              <MDButton color="success" fullWidth variant="outlined" type="submit">
                ثبت
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
}
